export default __webpack_public_path__ + "static/banner-17dc42310f7681c0a63d8d078778e63c.png";